import { render } from "./AnaliticalManaged.vue?vue&type=template&id=509ec4d2&scoped=true"
import script from "./AnaliticalManaged.vue?vue&type=script&lang=js"
export * from "./AnaliticalManaged.vue?vue&type=script&lang=js"

import "./AnaliticalManaged.vue?vue&type=style&index=0&id=509ec4d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509ec4d2"]])

export default __exports__